export default __webpack_public_path__ + "static/media/step2-7.d4245c5b.png";